import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const SiteVisitResultsAnalyzedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SITE_VISIT_RESULTS_ANALYZED),
  shouldCreateNewBid: z.boolean(),
  createdBidId: z.number().optional(),
});

export type SiteVisitResultsAnalyzedTaskAttempt = z.infer<typeof SiteVisitResultsAnalyzedTaskAttemptSchema>;
